<template>
    <li class="subnav-destination">
        <span v-if="link.routed"
              class="subnav-destination__link-wrapper"
              @click="onAppLinkClick">
            <router-link class="subnav-destination__link subnav-destination__link--app"
                         :to="{ name: linkUrl }">
                {{ link.text }}
            </router-link>
        </span>
        <a v-else-if="link.modal"
           class="subnav-destination__link subnav-destination__link--modal"
           :href="linkUrl" :target="link.target"
           @click="onModalLinkClick">
            {{ link.text }}
        </a>
        <a v-else
           class="subnav-destination__link subnav-destination__link--external"
           :href="linkUrl" :target="link.target"
           @click="onExternalLinkClick">
            {{ link.text }}
        </a>
    </li>
</template>

<script>

import NavigationLink from '@/models/navigation-link'
import Vuex from 'vuex'

export default {

    props: {
        link: {
            type: NavigationLink,
            required: true,
        },
    },

    computed: {
        ...Vuex.mapState([
            'partnerReferralId',
        ]),

        /**
         * @returns {string}
         */
        linkUrl() {
            return this.partnerReferralId && this.link.passReferral
                ? this.link.url.includes('?')
                    ? `${ this.link.url }&partref=${ this.partnerReferralId }`
                    : `${ this.link.url }?partref=${ this.partnerReferralId }`
                : this.link.url
        },
    },

    methods: {

        onAppLinkClick($event) {
            this.onLinkClick($event, 'app')
        },

        onExternalLinkClick($event) {
            this.onLinkClick($event, 'external', this.link.target === '_blank' ? 'new' : 'app')
        },

        onModalLinkClick($event) {
            this.onLinkClick($event, 'modal', 'app', () => {
                this.$eventbus.$emit(this.$appevents.showModal, this.link.modal, {
                    onClose: () => history.go(-2),
                })
            })
        },

        onLinkClick($event, type, target = null, action = null) {
            $event.linkType = type
            $event.linkTarget = target ? target : type
            if (action) $event.action = action
            this.$emit('click', $event)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.subnav-destination {
    padding: 0.5rem 0;
    position: relative;

    @include bp-min-small {
        padding: 0.2rem 0;
    }

    @include element('link') {
        width: 100%;
        display: inline-block;

            &:hover, &:active {
                text-decoration: underline;
            }
    }
}

.touch {

    .subnav-destination {
        @include element('link') {
            text-decoration: underline;
        }
    }
}

</style>
